import { getGameConfig } from '../../../config/gameConfig';
import type { House } from '../types';

export function getMaxWarmth(): number {
    return getGameConfig().population.warmth.maxWarmth;
}

export function getHouseHeatPerHour(house: House): number {
    const config = getGameConfig();
    const interval = Math.max(1, config.heat.coldInterval);
    const step = Math.max(0, config.heat.coldStep[house.type]);
    return (step / interval) * config.time.ticksPerHour;
}
